import update from 'immutability-helper';
import moment from "moment";
import { LOAD_EXTRATO } from './actions';

export var defaultState = {
    data: [],
    summary: {
        receitas_abertas: 0, receitas_realizadas: 0,
        despesas_abertas: 0, despesas_realizadas: 0,
        total_periodo: 0, saldo_inicial: 0, count: 0,
    },
    filter: {
        from: moment().startOf("month").format("YYYY-MM-DD"),
        to: moment().endOf("month").format("YYYY-MM-DD"),
    },
    isLoading: false,
};

var ACTION_HANDLERS = {
    [LOAD_EXTRATO.INIT]: function(state) {
        return update(state, { isLoading: { $set: true } });
    },
    [LOAD_EXTRATO.SUCCESS]: function(state, action) {
        return update(state, {
            isLoading: { $set: false },
            data: { $set: action.payload.data.data.records },
            summary: { $set: action.payload.data.data.summary },
            filter: { $set: action.meta.previousAction.payload.filter },
        });
    },
    [LOAD_EXTRATO.FAIL]: function(state) {
        return update(state, { isLoading: { $set: false } });
    },
};

export default function(state, action) {
    if (state === undefined) state = defaultState;
    var handler = ACTION_HANDLERS[action.type];
    return handler ? handler(state, action) : state;
};
